/**
 * SPDX-License-Identifier: MIT
 * Copyright (c) 2026 Solvetia. Original work by Solvetia — MIT white-label additions
 * to Chatwoot Community Edition. Not derived from the commercial code under enterprise/.
 */
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import BotDocumentsAPI from '../../api/botDocuments';
import { throwErrorMessage } from '../utils/api';

export const SET_BOT_DOCUMENTS_UI_FLAG = 'SET_BOT_DOCUMENTS_UI_FLAG';
export const SET_BOT_DOCUMENTS = 'SET_BOT_DOCUMENTS';
export const ADD_BOT_DOCUMENT = 'ADD_BOT_DOCUMENT';
export const DELETE_BOT_DOCUMENT = 'DELETE_BOT_DOCUMENT';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
  },
};

export const getters = {
  getBotDocuments($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(SET_BOT_DOCUMENTS_UI_FLAG, { isFetching: true });
    try {
      const response = await BotDocumentsAPI.get();
      commit(SET_BOT_DOCUMENTS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(SET_BOT_DOCUMENTS_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, formData) => {
    commit(SET_BOT_DOCUMENTS_UI_FLAG, { isCreating: true });
    try {
      const response = await BotDocumentsAPI.create(formData);
      commit(ADD_BOT_DOCUMENT, response.data);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(SET_BOT_DOCUMENTS_UI_FLAG, { isCreating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(SET_BOT_DOCUMENTS_UI_FLAG, { isDeleting: true });
    try {
      await BotDocumentsAPI.delete(id);
      commit(DELETE_BOT_DOCUMENT, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(SET_BOT_DOCUMENTS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [SET_BOT_DOCUMENTS_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [SET_BOT_DOCUMENTS]: MutationHelpers.set,
  [ADD_BOT_DOCUMENT]: MutationHelpers.setSingleRecord,
  [DELETE_BOT_DOCUMENT]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
